import React, { useCallback, useEffect, useState } from 'react';
import {
  Button,
  Modal,
  Row,
  Space,
  Typography,
  Form,
  Tabs,
  Card,
  Input,
  Table,
  message,
  Col,
} from 'antd';
import { leaveEditForm } from 'utils';
import { FormLabel } from 'components/common';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import type { ColumnsType } from 'antd/es/table';
import moment from 'moment';
import { loadProductCodeQuatity } from 'services/product';

const { Text } = Typography;
type Props = {
  onHide: () => void;
  onSubmit: (
    items: { [key: string]: number },
    data: any[],
    str: string,
    tab: string
  ) => void;
  defaultData: string[];
  defaultStr: string;
  skuList: { sku: string; upc: string }[];
  defaultTab: string;
};

// eslint-disable-next-line
export default (props: Props) => {
  const { onHide, onSubmit, defaultData, skuList, defaultStr, defaultTab } =
    props;
  const [selectedTab, setSelectTab] = useState<string>(defaultTab);
  const [data, setData] = useState<any[]>(defaultData);
  const [data2, setData2] = useState<any[]>([]);
  const [str, setStr] = useState(defaultStr);
  const [lastScan, setLastScan] = useState<{
    sku: string;
    time: string;
  }>();
  const [form] = Form.useForm();

  // const checkStr = useCallback((str: string) => {
  //   const temp = str.split('\n');
  //   const tempArr: any[] = [];
  //   let arr: string[] = [];
  //   temp.map((i) => {
  //     if (i) {
  //       if (arr.indexOf(i) === -1) {
  //         arr.push(i);
  //         tempArr.push({
  //           sku: i,
  //           qty: 1,
  //         });
  //       } else {
  //         tempArr[arr.indexOf(i)] = {
  //           sku: i,
  //           qty: tempArr[arr.indexOf(i)].qty + 1,
  //         };
  //       }
  //       return true;
  //     } else {
  //       return true;
  //     }
  //   });
  //   setData2(tempArr);
  //   return tempArr;
  // }, []);

  const checkStr2 = useCallback(async (str: string) => {
    const temp = str.split('\n');
    const tempArr: any[] = [];
    let arr: string[] = [];
    const codeMap: Record<string, { sku: string; qty: number }> = {};
    if (temp.length > 0) {
      const res = await loadProductCodeQuatity(temp);
      if (res && res.isSuccess) {
        if (res.data && res.data.length > 0) {
          res.data.map((i: any) => {
            codeMap[i.code] = { sku: i.sku, qty: i.code === i.sku ? 1 : i.qty };
            return true;
          });
        }
      }
      temp.map((i) => {
        if (i) {
          if (codeMap[i]) {
            if (arr.indexOf(codeMap[i].sku) === -1) {
              arr.push(i);
              tempArr.push({
                sku: codeMap[i].sku,
                qty: codeMap[i].qty,
              });
            } else {
              tempArr[arr.indexOf(codeMap[i].sku)] = {
                sku: codeMap[i].sku,
                qty: tempArr[arr.indexOf(codeMap[i].sku)].qty + codeMap[i].qty,
              };
            }
          } else {
            if (arr.indexOf(i) === -1) {
              arr.push(i);
              tempArr.push({
                sku: i,
                qty: 1,
              });
            } else {
              tempArr[arr.indexOf(i)] = {
                sku: i,
                qty: tempArr[arr.indexOf(i)].qty + 1,
              };
            }
          }
          return true;
        } else {
          return true;
        }
      });

      setData2(tempArr);
      return tempArr;
    } else {
      setData2([]);
      return [];
    }
  }, []);

  /**
   * handle submit event
   */
  const handleSubmit = useCallback(async () => {
    let items: { [key: string]: number } = {};
    if (selectedTab === 'single') {
      data.map((i) => {
        items[i.sku] = i.qty;
        return true;
      });
    } else {
      const t = await checkStr2(str);
      t.map((i) => {
        const index = skuList.findIndex(
          (j) => j.sku === i.sku || j.upc === i.sku
        );
        if (index > -1) {
          items[skuList[index].sku] = items[skuList[index].sku]
            ? items[skuList[index].sku] + i.qty
            : i.qty;
        }
        return true;
      });
    }
    onSubmit(items, data, str, selectedTab);
  }, [onSubmit, data, str, selectedTab, skuList, checkStr2]);
  /**
   * handle cancel event
   */
  const handleCancel = useCallback(async () => {
    const cancel = await leaveEditForm({}, form);
    if (cancel) {
      onHide();
    }
  }, [onHide, form]);

  useEffect(() => {
    if (defaultStr) {
      checkStr2(defaultStr);
    }
  }, [defaultStr, checkStr2]);

  const onKeyDown = async (evt: any) => {
    if ([9, 13].indexOf(evt.keyCode) > -1) {
      form.setFieldsValue({
        scanValue: undefined,
      });
      evt.preventDefault();
      if (evt.target.value) {
        const newValue = `${evt.target.value}`;
        const idx = skuList.findIndex(
          (i) => i.sku === newValue || i.upc === newValue
        );
        if (idx > -1) {
          const index = data.findIndex((i) => i.sku === skuList[idx].sku);
          if (index > -1) {
            const temp = [...data];
            temp[index] = {
              sku: skuList[idx].sku,
              upc: skuList[idx].upc,
              qty: temp[index].qty + 1,
            };
            setData([...temp]);
          } else {
            setData([
              {
                sku: skuList[idx].sku,
                upc: skuList[idx].upc,
                qty: 1,
              },
              ...data,
            ]);
          }
          setLastScan({
            sku: newValue,
            time: moment().format('hh:mm:ssA'),
          });
        } else {
          const res = await loadProductCodeQuatity([newValue]);
          if (res && res.isSuccess) {
            if (res.data && res.data.length > 0) {
              const { sku, qty: qqty } = res.data[0];
              const idx2 = skuList.findIndex((i) => i.sku === sku);
              if (idx2 > -1) {
                const index2 = data.findIndex(
                  (i) => i.sku === skuList[idx2].sku
                );
                if (index2 > -1) {
                  const temp = [...data];
                  temp[index2] = {
                    sku: skuList[idx2].sku,
                    upc: skuList[idx2].upc,
                    qty: temp[index2].qty + qqty,
                  };
                  setData([...temp]);
                } else {
                  setData([
                    {
                      sku: skuList[idx2].sku,
                      upc: skuList[idx2].upc,
                      qty: qqty,
                    },
                    ...data,
                  ]);
                }
                setLastScan({
                  sku: newValue,
                  time: moment().format('hh:mm:ssA'),
                });
              } else {
                message.error(`[${newValue}] not found`);
              }
            } else {
              message.error(`[${newValue}] not found`);
            }
          } else {
            message.error(`[${newValue}] not found`);
          }
        }
      }
    }
  };

  const columns: ColumnsType<any> = [
    {
      title: 'SKU',
      dataIndex: 'sku',
      key: 'sku',
      render: (text) =>
        skuList.findIndex((i) => i.sku === text) > -1 ? (
          <Text>{text}</Text>
        ) : (
          <Text style={{ color: '#ff4d4f' }} delete>
            {text}
          </Text>
        ),
    },
    {
      title: 'UPC',
      dataIndex: 'upc',
      key: 'upc',
      render: (text, record) =>
        skuList.findIndex((i) => i.sku === record.sku) > -1 ? (
          <Text>{text}</Text>
        ) : (
          <Text style={{ color: '#ff4d4f' }} delete>
            {text}
          </Text>
        ),
    },
    {
      title: 'Qty',
      dataIndex: 'qty',
      key: 'qty',
      render: (text, record) =>
        skuList.findIndex((i) => i.sku === record.sku) > -1 ? (
          <Text>{text}</Text>
        ) : (
          <Text style={{ color: '#ff4d4f' }} delete>
            {text}
          </Text>
        ),
    },
  ];

  const columns2: ColumnsType<any> = [
    {
      title: 'SKU / UPC',
      dataIndex: 'sku',
      key: 'sku',
      render: (text) =>
        skuList.findIndex((i) => i.sku === text || i.upc === text) > -1 ? (
          <Text>{text}</Text>
        ) : (
          <Text style={{ color: '#ff4d4f' }} delete>
            {text}
          </Text>
        ),
    },
    {
      title: 'Qty',
      dataIndex: 'qty',
      key: 'qty',
      render: (text, record) =>
        skuList.findIndex((i) => i.sku === record.sku || i.upc === record.sku) >
        -1 ? (
          <Text>{text}</Text>
        ) : (
          <Text style={{ color: '#ff4d4f' }} delete>
            {text}
          </Text>
        ),
    },
  ];

  return (
    <Modal
      title="Scan to Recieve"
      centered
      visible={true}
      width={800}
      destroyOnClose={true}
      onCancel={handleCancel}
      footer={
        <Row justify="end">
          <Space>
            <Button
              key="submit"
              type="primary"
              onClick={handleSubmit}
              icon={<CheckOutlined />}
            >
              Continue
            </Button>
            <Button onClick={handleCancel} icon={<CloseOutlined />}>
              Cancel
            </Button>
          </Space>
        </Row>
      }
    >
      <Form form={form}>
        <Tabs activeKey={selectedTab} onChange={setSelectTab}>
          <Tabs.TabPane tab="Single Scan" key="single">
            <Card
              title={
                <Row justify="space-between">
                  <Space>
                    <FormLabel>Scan SKU / UPC</FormLabel>
                    <Form.Item noStyle name="scanValue">
                      <Input
                        allowClear
                        style={{ width: 200 }}
                        autoFocus
                        onKeyDown={onKeyDown}
                      />
                    </Form.Item>
                  </Space>
                  {lastScan && (
                    <Row>
                      <Space>
                        <Typography.Text
                          style={{ fontSize: 12 }}
                          type="secondary"
                        >{`Last scan: ${lastScan.sku}`}</Typography.Text>
                        <Typography.Text
                          style={{ fontSize: 12 }}
                          type="secondary"
                        >{`Scanned time: ${lastScan.time}`}</Typography.Text>
                      </Space>
                    </Row>
                  )}
                </Row>
              }
            >
              <Table
                rowKey="sku"
                scroll={{ y: 240 }}
                dataSource={data}
                columns={columns}
                pagination={false}
              />
            </Card>
          </Tabs.TabPane>
          <Tabs.TabPane tab="Paste Multiple" key="multiple">
            <Row>
              <Col span={12}>
                <Space direction="vertical">
                  <Input.TextArea
                    style={{ width: 350 }}
                    rows={16}
                    value={str}
                    onChange={(e) => setStr(e.target.value)}
                  />
                  <Button
                    onClick={() => {
                      checkStr2(str);
                    }}
                  >
                    Check
                  </Button>
                </Space>
              </Col>
              <Col span={12}>
                <Table
                  rowKey="sku"
                  scroll={{ y: 322 }}
                  dataSource={data2}
                  columns={columns2}
                  pagination={false}
                />
              </Col>
            </Row>
          </Tabs.TabPane>
        </Tabs>
      </Form>
    </Modal>
  );
};
